import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Card, Spinner, Form } from "react-bootstrap";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import moment from "moment";
import { toast } from "react-toastify";
import OtpVerficationPopup from "./OtpVerificationPopup";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { IconCreditCard } from "@tabler/icons-react";
import ComanConfirmationModal from "../../../components/ComanConfirmationModal";
import OtpVerifyPopup from "../../customer/OtpVerifyPopup";
import CustomerCardEdit from "../../customer/CustomerCardEdit";

function CardDetails({ show, onClose, emailId, onOtpVerified }) {
  const [cardDetails, setCardDetails] = useState([]);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [showEditOptPopup, setShowEditOptPopup] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [cardId, setCardId] = useState(null);
  const [getCard, setGetCard] = useState(false);
  const [getCardDetails, setGetCardDetails] = useState({ email: "" });
  const [getCardErrors, setGetCardErrors] = useState({ email: "" });
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [verifiedCardData, setVerifiedCardData] = useState(null);
  const { postData: fetchReview, data: fetchedReview } = usePostRequest(
    API_ENDPOINTS.GET_CUSTOMER_CARD
  );

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const { order_id } = useParams();

  const { postData: sendPaymentOtp, data: otpData } = usePostRequest(
    API_ENDPOINTS.PAYMENT_OTP
  );

  const {
    isLoading: Verifying,
    postData: VerifyCustomerOtp,
    data: Verified,
  } = usePostRequest(API_ENDPOINTS.SEND_OTP_CARDS);

  const { isLoading: isLoadingGetCard, postData: postGetCard } = usePostRequest(
    API_ENDPOINTS.VERIFY_CUSTOMER_EMAIL
  );

  useEffect(() => {
    if (show) {
      fetchReview({ email: emailId, other_id: order_id, type: "ORDER" });
    }
  }, [show]);

  useEffect(() => {
    if (fetchedReview?.data) {
      setCardDetails(fetchedReview.data);
    }
  }, [fetchedReview]);

  const user = useSelector((state) => state.auth.user);
  const canEditCards = user?.permissions?.manage_cards?.includes("write");

  const onOtpSuccess = (res) => {
    toast.success(res?.message || "OTP sent successfully");
    setShowOtpPopup(true);
    onClose();
  };

  const onOtpError = (err) => {
    toast.error(err?.message || "Failed to initiate payment OTP");
    // setShowOtpPopup(true); // this will be used in onOtpSuccess
    // onClose(); // this will be used in onOtpSuccess
  };

  const handleOtp = (cardInfo) => {
    setPaymentData(cardInfo);
    sendPaymentOtp(
      {
        id: cardInfo?.id,
        type: "order_payment",
        // order_id: order_id,
        // user_name: cardInfo?.info_name,
        // user_invoice: cardInfo?.invoice_number,
      },
      onOtpSuccess,
      onOtpError
    );
  };

  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleGetCardChange = (e) => {
    const { name, value } = e.target;
    let error = "";

    if (value.trim() === "") {
      error = `${name} is required`;
    } else if (name === "email" && !validateEmail(value)) {
      error = "Invalid email address";
    }

    setGetCardDetails({ ...getCardDetails, [name]: value });
    setGetCardErrors({ ...getCardErrors, [name]: error });
  };

  const handleCancel = () => {
    setGetCard(false);
    setGetCardDetails({ email: "" });
    setGetCardErrors({ email: "" });
  };

  const handleGetCardSubmit = (e) => {
    e.preventDefault();
    const isValid =
      getCardDetails.email.trim() !== "" && getCardErrors.email === "";

    if (!isValid) {
      toast.error("Please correct the email before submitting");
      return;
    }

    const payload = {
      other_id: order_id,
      email: getCardDetails.email,
    };

    postGetCard(
      payload,
      (res) => {
        console.log("this api ran")
        toast.success(res?.message || "Card linked successfully");
        // fetchReview({ email: emailId, order_id: order_id }, onSuccess, onError);
        setGetCard(false);
        setGetCardDetails({ email: "" });
        setGetCardErrors({ email: "" });
      },
      (err) => toast.error(err || "Failed to generate link for card")
    );
  };

  const onSuccess = (response) => setCardDetails(response?.data || []);
  const onError = (err) =>
    toast.error(
      err?.message ||
      "No valid card details found. Please add card details first."
    );

  const handleOtpVerified = (response) => {
    console.log("OTP Verified → CardDetails:", response);

    if (onOtpVerified) {
      onOtpVerified(response);
    }
  };

  const openModal = (id) => {
    let modalMessage =
      "Are you sure you want to view/edit customer's card details? An OTP will be sent for verification if you proceed.";
    let modalTitle = "Edit Customer Card Details";
    let type = "info";
    let modalIcon = <IconCreditCard />;
    let action = "success";

    const handleSendOtp = () => {
      VerifyCustomerOtp({ id }, onSuccessVerify, onErrorVerify);
      setIsModalOpen({ ...isModalOpen, show: false });
      onClose();
    };

    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: handleSendOtp,
      title: modalTitle,
      icon: modalIcon,
      type,
    });
  };

  const onSuccessVerify = (res) => {
    toast.success(res?.message);
    // GetPackigSlip({ order_id: orderId });
    setShowEditOptPopup(true);
  };

  const onErrorVerify = (err) => {
    toast.error(err?.message || "Failed to delete record");
  };

  const handleOtpVerifiedEdit = (verifiedResponse) => {
    setVerifiedCardData(verifiedResponse);
    setShowEditOptPopup(false);
    setShowCardDetails(true);
  };

  return (
    <>

      {showCardDetails && (
        <CustomerCardEdit
          show={showCardDetails}
          onClose={() => setShowCardDetails(false)}
          formData={verifiedCardData}
        />
      )}

      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />

      {showEditOptPopup && (
        <OtpVerifyPopup
          show={showEditOptPopup}
          onClose={() => setShowEditOptPopup(false)}
          formData={Verified}
          onVerified={handleOtpVerifiedEdit}
        />
      )}

      {showOtpPopup && (
        <OtpVerficationPopup
          show={showOtpPopup}
          onClose={() => setShowOtpPopup(false)}
          formData={paymentData}
          onVerified={handleOtpVerified}
        />
      )}

      <Modal show={show} onHide={onClose} size="xl">
        <Modal.Header className="d-flex gap-3" closeButton>
          <h5>Card Details</h5>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive mail_wrapper p-0 border-0 mb-0 box-shadow-none">
            <Table className="table-bordered card-table">
              <thead>
                <tr>
                  <th>CARDHOLDER NAME</th>
                  <th>CARD NUMBER</th>
                  <th>CARD EXPIRY</th>
                  <th>INVOICE NUMBER</th>
                  <th>CREATED DATE</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {cardDetails.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No card details found.
                    </td>
                  </tr>
                ) : (
                  cardDetails.map((card) => (
                    <>
                      <tr key={card.id}>
                        <td>{card.info_name}</td>
                        <td>{"**** **** **** " + card.info_number}</td>
                        <td>{card.info_expiry}</td>
                        <td>{card.invoice_number || "N/A"}</td>
                        <td>{moment(card.created_at).format("MM/DD/YYYY")}</td>
                        <td className="d-flex gap-2">
                          <Button
                            className="w-auto"
                            style={{ minWidth: "auto" }}
                            onClick={() => handleOtp(card)}
                          >
                            Pay
                          </Button>
                          <Button
                            className="w-auto"
                            style={{ minWidth: "auto" }}
                            onClick={() => openModal(card?.id)}
                            disabled={!canEditCards}
                          >
                            View/Edit
                          </Button>
                        </td>
                      </tr>
                      <tr key={card.id}>
                        <td colSpan="6" className="text-end">
                          Notes: {card.note || "N/A"}
                        </td>
                      </tr>
                    </>
                  ))
                )}
              </tbody>
            </Table>
          </div>

          {/* <Card className="add_credit_card mb-3 mt-3">
            <Card.Header className="card_header">GET NEW CARD</Card.Header>
            <Card.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label className="required">EMAIL</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={getCardDetails.email}
                    onChange={handleGetCardChange}
                    placeholder="Enter your email address"
                  />
                  {getCardErrors.email && (
                    <div className="text-danger">{getCardErrors.email}</div>
                  )}
                </Form.Group>

                <div className="d-flex justify-content-center gap-2">
                  <Button
                    onClick={handleGetCardSubmit}
                    type="submit"
                    variant="primary"
                    disabled={
                      isLoadingGetCard ||
                      getCardDetails.email.trim() === "" ||
                      getCardErrors.email
                    }
                  >
                    {isLoadingGetCard ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Get Card"
                    )}
                  </Button>
                  <Button
                    type="button"
                    variant="outline-secondary"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card> */}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CardDetails;
